import React from 'react';
import { Form } from 'react-bootstrap';

/**
 * @param {options: {name: string, value: number | string }[], value: number[] | string[], onChange: (value: number[] | string[])}}
 * @returns
 */
export default function MultiSelect({ options, value, onChange, label = '' }) {
  if (!options || !Array.isArray(options) || !options.length) {
    return 'No options available';
  }

  const onCheck = (option) => {
    if (value.includes(option.value)) onChange(value.filter((ele) => ele !== option.value));
    else onChange([...value, option.value]);
  };

  return (
    <Form.Group className="d-flex flex-column overflow-y-auto gap-3 max-h-25 max-h-sm-3xs">
      {label && <Form.Label className="fs-6">{label}</Form.Label>}
      {options &&
        options?.map((option, index) => (
          <Form.Check
            key={index}
            disabled={option.forceSelect}
            type="checkbox"
            label={option.name}
            checked={value.includes(option.value)}
            onChange={() => onCheck(option)}
          />
        ))}
    </Form.Group>
  );
}
